import React, { useEffect, useMemo } from "react";
import styles from '../styles/questionType.module.scss'
import Select from "@/wmCompoments/select";
import { useFeedbackConfig, useOrderList } from "../hooks/api";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface Props {
    name: string

}
const QuestionType = (props: Props) => {
    const { t } = useTranslation('feedback')
    
    const { name } = props ?? {}

    const { data } = useFeedbackConfig()

    const {
        register,
        setValue,
        watch,
        trigger,
        formState: { errors },
    } = useFormContext();

    // 注册字段及校验规则
    useEffect(() => {
        register(name, {
            required: t('selectIssueType')
        });
    }, [register, name]);

    const value = watch(name);


    const options = useMemo(() => {
        if (data) {
            return data?.map((v) => {
                return {
                    ...v,
                    label: v.title,
                    value: v.id
                }
            })
        }
        return []
    }, [data])

    return <div className={styles.warpper}>
        <div>
            <span className={styles.required}>*</span>
            <span>{t('issueType')}</span>
        </div>
        <div>
            <Select
                value={value?.value}
                options={options}
                className={styles.select}
                onChange={(v, o) => {
                    setValue(name, o)
                    trigger(name)
                }}
                placeholder={t('selectIssueType')}
            />
        </div>
        {errors[name] && (
            <div className={styles.errorText}>{errors[name]?.message?.toString()}</div>
        )}
    </div>
}

export default QuestionType